import { render } from "./App.vue?vue&type=template&id=0b5cc510"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0b5cc510&lang=scss"

import exportComponent from "/opt/164office/gitee/164office-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__